import { Navigate, useLocation, useParams } from "react-router-dom";

export default function SectionPeopleIndexRedirect() {
  const { sectionId } = useParams();
  const { search } = useLocation();

  if (!sectionId) {
    return null;
  }

  return <Navigate to={`/sections/${sectionId}/people/section-people${search}`} replace />;
}
